<template>
    <div class="wrap">
        <!-- <div class="title">
            <h2 class="title_left">主体汇总</h2>
        </div> -->
        <div class="innerBox">
            <div class="filtrate">
                <el-input placeholder="主体名称、营业执照、许可证号、管理员账号" class="w300 seekIpt" v-model="searchInput"
                    @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                </el-input>
                <el-cascader class="ml20 w300" v-model="areaId" :options="areaList.options" @change="areaChange"
                    :props="areaList.props" clearable placeholder="所属行政区" ref="cascader"></el-cascader>
                <el-select class="ml20 w200" v-model="buyerTypeValue" @change="buyerTypeChange" multiple collapse-tags
                    placeholder="行业类型">
                    <el-option v-for="item in buyerTypes" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="ml20 w120" v-model="scTypeValue" @change="scTypeChange" clearable placeholder="公立/私立">
                    <el-option v-for="item in scTypes" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="ml20 w120" v-model="availableValue" @change="stateChange" clearable size="small"
                    placeholder="启用状态">
                    <el-option v-for="item in availableTypes" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="ml20 w120" v-model="cameraValue" @change="cameraChange" clearable size="small"
                    placeholder="摄像头">
                    <el-option v-for="item in cameraTypes" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="ml20 w120" v-model="gatherValue" @change="gatherChange" clearable size="small"
                    placeholder="采集模式">
                    <el-option v-for="item in gatherTypes" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="ml20 w120" v-model="traceValue" @change="traceChange" clearable size="small"
                    placeholder="溯源模式">
                    <el-option v-for="item in traceTypes" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div>
                <el-button class="mt20" @click="add" icon="el-icon-circle-plus-outline" type="primary">添加</el-button>
                <el-button class="ml20" @click="addBatch('TOB')" type="primary">从TOB添加</el-button>
                <el-button class="ml20" @click="addBatch('TOG')" type="primary">从TOG添加</el-button>
                <el-button class="ml20" @click="addBatch('CFDA')" type="primary">从三小添加</el-button>
                <el-button class="ml20" @click="batch('批量启用')" :disabled="isDisabled" type="primary">批量启用</el-button>
                <el-button class="ml20" @click="batch('批量禁用')" :disabled="isDisabled" type="primary">批量禁用</el-button>
                <el-button class="ml20" @click="batchModule" :disabled="isDisabled" type="primary">批量配置角色</el-button>
            </div>
            <div class="table-div">
                <el-table :data="tableData" border style="width:calc(100% - 10px); margin-top: 10px"
                    :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}"
                    v-loading="tableLoading" @selection-change="handleSelectionChange">
                    <el-table-column label="序号" width="80" type="selection">
                    </el-table-column>
                    <el-table-column prop="buyerName" label="主体名称" min-width="150" show-overflow-tooltip fixed="left">
                        <template slot-scope="scope">
                            {{scope.row.buyerName ? scope.row.buyerName: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="adminAccount" label="管理员账号" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.adminAccount ? scope.row.adminAccount: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="creditCode" label="营业执照" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.creditCode ? scope.row.creditCode: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="licence" label="许可证号" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.licence ? scope.row.licence: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="areaName" label="所属区县" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.areaName ? scope.row.areaName: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="qualityLevel" label="量化等级" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.qualityLevel ? scope.row.qualityLevel: '-'}}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="legalPerson" label="负责人" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.legalPerson ? scope.row.legalPerson: '-'}}
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="buyerType" label="行业类型" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.buyerType ? scope.row.buyerType: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="scType" label="公立私立" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.scType ? scope.row.scType: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="acquisitionMode" label="采集模式" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.acquisitionMode ? scope.row.acquisitionMode: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="traceabilityMode" label="溯源模式" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.traceabilityMode ? scope.row.traceabilityMode: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="hasCamera" label="摄像头" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.hasCamera ? scope.row.hasCamera: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="togId" label="TOGID" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.togId ? scope.row.togId: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="tobId" label="TOBID" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.tobId ? scope.row.tobId: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="gpsAddress" label="GPS" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.gpsAddress ? scope.row.gpsAddress: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="地址" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.address ? scope.row.address: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateTime" label="更新时间" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.updateTime ? scope.row.updateTime: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="available" label="启用禁用" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.available ? scope.row.available: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" min-width="660">
                        <template slot-scope="scope">
                            <el-button :disabled="scope.row.available === '禁用'" @click="edit(scope.row)" type="primary" plain size="small">编辑</el-button>
                            <el-button @click="detail(scope.row)" type="primary" plain size="small">详情</el-button>
                            <el-button @click="subTypeUpdate(scope.row)" type="primary" plain size="small">类型修改
                            </el-button>
                            <el-button @click="cameraManage(scope.row)" type="primary" plain size="small">摄像头
                            </el-button>
                            <!-- <el-button @click="cameraManage(scope.row)" type="primary" plain size="small">GPS地址</el-button> -->
                            <el-button v-if="scope.row.available === '启用'" key="unAvailable"
                                @click="useChange(scope.row)" type="danger" plain size="small">禁用</el-button>
                            <el-button v-else key="available" @click="useChange(scope.row)" type="warning" plain
                                size="small">启用</el-button>
                            <el-button @click="qrCode(scope.row)" type="primary" plain size="small">二维码</el-button>
                            <el-button @click="goComment(scope.row)" type="primary" plain size="small">评价</el-button>
                            <el-button @click="accessControl(scope.row)" type="primary" plain size="small">门禁</el-button>
                            <el-button @click="switchBtn(scope.row)" type="primary" plain size="small">智能监测</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog class="subtype-dialog" v-if="dialogVisible" :visible.sync="dialogVisible"
                :close-on-click-modal="false" title="行业类型修改" style="padding-top: 0px;">
                <el-select class="ml20 w200" v-model="subTypeValue" placeholder="行业类型">
                    <el-option v-for="item in subTypes" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <div class="footer">
                    <el-button @click="cancle" round>关闭</el-button>
                    <el-button type="primary" @click="submit" round>保存</el-button>
                </div>
            </el-dialog>
            <el-dialog class="subtype-dialog qrCode-dialog" v-if="qrCodeShow" :visible.sync="qrCodeShow"
                :close-on-click-modal="false" title="小程序学校二维码" style="padding-top: 0px;">
                <p>请使用微信扫描二维码</p>
                <el-row>
                    <el-col :span="24" v-loading='loadingQrCode'>
                        <div class="grid-content bg-purple">
                            <p>{{QrCode_.text=='FXSA'?'放心食安':'校餐卫士'}}</p>
                            <img :src='QrCode_.src' />
                        </div>
                        <el-button type="primary" plain size="small" @click='down'>下载二维码</el-button>
                    </el-col>
                    <!-- <el-col :span="12">
                        <div class="grid-content bg-purple-light">
                            <p>放心食安</p>
                            <img :src='fxsaQrCodeSrc' />
                        </div>
                        <el-button type="primary" plain size="small">下载二维码</el-button>
                    </el-col> -->
                </el-row> 
            </el-dialog>

            <transfer-dialog 
              v-if="transferDialogVisible"
              :title="transferTitle"
              :type="transferType"
              :transfer-dialog-visible="transferDialogVisible" 
              @closeTransferDialog="closeTransferDialogVisible">
            </transfer-dialog> 
            <module-dialog
                v-if="moduleDialogVisible"
                :module-dialog-visible="moduleDialogVisible" 
                @closeDialog="closeModule"
                :dataArr="entityIdStr"
            >
            </module-dialog>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange"
                style="margin-top:10px;margin-right:10px"></ybPagination>
        </div>
    </div>
</template>
<script>
    import * as subManageApi from '@/api/subManage';
    import ybPagination from '@/components/ybPagination';
    import * as mapping from '@/utils/enumList'
    import TransferDialog from './TransferDialog'
    import ModuleDialog from './moduleDialog'
    export default {
        name: 'subjectList',
        components: {
            ybPagination,
            TransferDialog,
            ModuleDialog
        },
        data() {
            return {
                loadingQrCode: false,
                qrCodeShow: false,
                QrCode_: {
                    src: '',
                    text: ''
                },
                searchInput: '',
                parentId: '0',
                areaId: '',
                areaList: {
                    selOptions: [],
                    options: [],
                    parentCode: '',
                    props: {
                        checkStrictly: true,
                        expandTrigger: 'hover',
                        value: 'areaId',
                        label: 'areaName',
                        children: 'children',
                        lazy: true,
                        lazyLoad(node, resolve) {}
                    }
                },
                buyerTypes: mapping.getKeyVal('buyerType'),
                scTypes: mapping.getKeyVal('scType'),
                availableTypes: mapping.getKeyVal('available'),
                cameraTypes: mapping.getKeyVal('hasCamera'),
                gatherTypes: mapping.getKeyVal('acquisitionMode'),
                traceTypes: mapping.getKeyVal('traceabilityMode'),
                buyerTypeValue: [],
                scTypeValue: '',
                availableValue: '',
                cameraValue: '',
                gatherValue: '',
                traceValue: '',
                updateParams: {
                    entityId: '',
                    available: ''
                },
                tableLoading: false,
                tableData: [],
                page: {
                    pageSize: 10,
                    pageNum: 1,
                    total: 10
                },
                entityIdStr: '',
                dialogVisible: false,
                moduleDialogVisible:false,
                subTypeValue: '',
                subTypes: mapping.getKeyVal('buyerType'),
                subTypeParams: {
                    accessAreaCode: '',
                    buyerType: '',
                    entityId: ''
                },

                transferDialogVisible: false,
                transferTitle: '从TOB添加',
                transferType: 'TOB'
            }
        },
        computed: {
            isDisabled: function () {
                return this.entityIdStr ? false : true
            },
            params: function () {
                let buyerTemp
                if (this.buyerTypeValue.length === 0) {
                    this.buyerTypeValue = ''
                } else {
                    buyerTemp = this.buyerTypeValue.join(',')
                }
                return {
                    areaId: this.areaList.selOptions[this.areaList.selOptions.length - 1],
                    buyerTypeStr: buyerTemp,
                    current: this.page.pageNum,
                    keyword: this.searchInput,
                    scType: this.scTypeValue,
                    size: this.page.pageSize,
                    available: this.availableValue,
                    acquisitionMode: this.gatherValue,
                    hasCamera: this.cameraValue,
                    traceabilityMode: this.traceValue
                }
            },
            leftParams: function () {
                return {
                    areaId: this.leftAreaList.selOptions[this.leftAreaList.selOptions.length - 1],
                    current: this.leftPage.pageNum,
                    keyword: this.leftKeyWord,
                    size: this.leftPage.pageSize,
                }
            },
            isLeftDisabled: function () {
                return this.leftMultipleSelection.length > 0 ? false : true
            },
            isRightDisabled: function () {
                return this.rightMultipleSelection.length > 0 ? false : true
            },
            // 右表是否有筛选条件
            isRightFilter: function () {
                return this.rightKeyWord.length > 0 || this.rightAreaList.selOptions.length > 0
            },
        },
        methods: {
            down() {
                let code = encodeURI(this.QrCode_.text=='FXSA'?'放心食安':'校餐卫士');
                window.location.href = `/api/guard/common/file/download?fileUrl=${this.QrCode_.src}&fileName=${code}`;
            },
            qrCode(item) {
                this.QrCode_.src = ''
                this.QrCode_.text = ''
                this.loadingQrCode = true;
                subManageApi.xcwsEntityQrcode({
                    entityId: item.guid,
                    type: ''
                }).then(r => {
                    if (r.code == 200) {
                        this.QrCode_.src = r.data.qrCodeUrl
                        this.QrCode_.text = r.data.type
                        this.loadingQrCode = false;
                    }

                })
                this.qrCodeShow = true;
            },
            // 门禁
            accessControl(row){
                this.$router.push({
                    name: 'accessControlList',
                    query: {
                        entityId: row.guid,
                        tobId: row.tobId,
                        togId: row.togId,
                        buyerName: row.buyerName
                    }
                })
            },
            // 智能监测
            switchBtn(row){
                this.$router.push({
                    name: 'switchList',
                    query: {
                        entityId: row.guid,
                        tobId: row.tobId,
                        togId: row.togId,
                        buyerName: row.buyerName
                    }
                })
            },
            // 搜索
            search() {
                this.page.pageNum = 1
                this.tableRefresh()
            },
            // 行政区域筛选
            areaChange(value) {
                this.page.pageNum = 1
                this.areaList.selOptions = value
                this.tableRefresh()
            },
            // 行业类型筛选
            buyerTypeChange(value) {
                this.page.pageNum = 1
                this.tableRefresh()
            },
            // 公立私立筛选
            scTypeChange(value) {
                this.page.pageNum = 1
                this.tableRefresh()
            },
            // 启用状态筛选
            stateChange(value) {
                this.page.pageNum = 1
                this.tableRefresh()
            },
            cameraChange(value) {
                this.page.pageNum = 1
                this.tableRefresh()
            },
            gatherChange(value) {
                this.page.pageNum = 1
                this.tableRefresh()
            },
            traceChange(value) {
                this.page.pageNum = 1
                this.tableRefresh()
            },
            add() {
                this.$router.push({
                    name: 'SubjectAdd',
                    query: {
                        type: 'add'
                    }
                })
            },
            // 批量启用/禁用
            batch(batchString) {
                this.$confirm(`是否确定${batchString}主体?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (batchString === '批量启用') {
                        subManageApi.batchEnable(this.entityIdStr)
                        .then(res => {
                            if (res.code === 200) {
                                this.$message.success(`${batchString}成功!`)
                                this.tableRefresh()
                            }
                        }).catch(err => {})
                    } else {
                        subManageApi.batchDisable(this.entityIdStr)
                        .then(res => {
                            if (res.code === 200) {
                                this.$message.success(`${batchString}成功!`)
                                this.tableRefresh()
                            }
                        }).catch(err => {})
                    }
                }).catch(err => {})
            },
            // 多选
            handleSelectionChange(val) {
                let entityIdArr = []
                val.forEach(item => {
                    entityIdArr.push(item.guid)
                })
                this.entityIdStr = entityIdArr.join(',')
            },
            edit(row) {
                this.$router.push({
                    name: 'SubjectAdd',
                    query: {
                        type: 'edit',
                        id: row.guid
                    }
                })
            },
            detail(row) {
                this.$router.push({
                    name: 'SubjectDetail',
                    query: {
                        id: row.guid
                    }
                })
            },
            goComment(row){
                this.$router.push({
                    name: 'CommentList',
                    query: {
                        id: row.guid
                    }
                })
            },
            // 行业类型修改按钮
            subTypeUpdate(row) {
                this.subTypeValue = mapping.valToKey('buyerType', row.buyerType)
                this.subTypeParams.entityId = row.guid
                this.subTypeParams.accessAreaCode = row.accessAreaCode
                this.dialogVisible = true
            },
            cancle() {
                this.dialogVisible = false
            },
            submit() {
                this.subTypeParams.buyerType = this.subTypeValue
                subManageApi.subTypeUpdate(this.subTypeParams).then(res => {
                    if (res.code === 200) {
                        this.dialogVisible = false
                        this.tableRefresh()
                    }
                }).catch(err => {})
            },
            // 摄像头管理
            cameraManage(row) {
                this.$router.push({
                    name: 'CameraList',
                    query: {
                        entityId: row.guid,
                        tobId: row.tobId,
                        togId: row.togId,
                        buyerName: row.buyerName
                    }
                })
            },
            // 禁用/启用
            useChange(row) {
                this.$confirm('是否确定' + (row.available === '启用' ? '禁用' : '启用') + '该主体?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.updateParams.entityId = row.guid;
                    this.updateParams.available = row.available === '禁用' ? '1' : '0';
                    subManageApi.availableUpdate(this.updateParams).then(r => {
                        if (r.code === 200) {
                            this.$message.success(row.available === '禁用' ? '启用成功!' : '禁用成功!')
                            this.tableRefresh();
                        }
                    }).catch(err => {});
                }).catch(e => {});
            },
            tableRefresh() {
                this.tableLoading = true;
                subManageApi.subjectList(this.params).then(r => {
                    if (r.code === 200) {
                        let data = r.data.records
                        data.forEach(el => {
                            el.scType = mapping.keyToVal('scType', el.scType)
                            el.buyerType = mapping.keyToVal('buyerType', el.buyerType)
                            el.available = mapping.keyToVal('available', el.available)
                            el.qualityLevel = mapping.keyToVal('qualityLevel', el.qualityLevel)
                            el.acquisitionMode = mapping.keyToVal('acquisitionMode', el.acquisitionMode)
                            el.traceabilityMode = mapping.keyToVal('traceabilityMode', el
                                .traceabilityMode)
                            el.hasCamera = mapping.keyToVal('hasCamera', el.hasCamera)
                        })
                        this.tableData = data
                        this.page.total = parseInt(r.data.total)
                    }
                    this.tableLoading = false;
                }).catch(err => {})
            },
            // 页数改变
            pageCurrentChange(num) {
                if (num !== this.page.pageNum) {
                    this.page.pageNum = num;
                    this.tableRefresh();
                }
            },
            // 页数据量改变
            pageSizeChange(size) {
                if (size !== this.page.pageSize) {
                    this.page.pageSize = size;
                    this.tableRefresh();
                }
            },

            closeTransferDialogVisible () {
              this.transferDialogVisible = false;
            },
            addBatch(type) {
              switch(type) {
                case "TOB":
                    this.transferTitle = "从TOB添加";
                    break;
                case "TOG":
                    this.transferTitle = "从TOG添加";
                    break;
                case "CFDA":
                    this.transferTitle = "从三小添加";
                    break;
              }
              this.transferType = type;
              this.transferDialogVisible = true;
            },
            batchModule(){
                this.moduleDialogVisible = true
            },
            closeModule(){
                this.moduleDialogVisible = false
            }
        },
        created() {
            let that = this;
            that.areaList.props.lazyLoad = function (node, resolve) {
                let code = node.value ? node.value : that.parentId;
                if (code.length > 6) {
                    return resolve([])
                }
                subManageApi.getAreaList({
                    parentId: code
                }).then(r => {
                    if (r.code === 200) {
                        resolve(r.data)
                    }
                });
            }
            this.tableRefresh()
        }
    }
</script>
<style lang="scss" scoped>
    .wrap {
        width: 100%;
        height: calc(100% - 40px);
        text-align: left;
        .table-div {
          .el-button+.el-button {
            margin-left: 4px;
          }
        }
    }

    .subtype-dialog::v-deep .el-dialog {
        width: 300px;
    }

    .addsub-dialog::v-deep .el-dialog {
        width: 1800px;

        .addsub-body {
            display: flex;
            display: -webkit-flex;
            justify-content: space-between;
            align-items: flex-start;

            .move-btn {
                align-self: center;
                // padding-top: 240px;
                .el-button {
                    display: block;
                    font-size: 16px;
                    font-weight: 700;
                }
            }

            .el-table {
                max-height: 550px;
                overflow-y: auto;
            }
        }
    }

    .footer {
        margin-top: 20px;
        text-align: right;
    }

    .qrCode-dialog {
        text-align: center;

        p {
            font-size: 16px;
            margin-bottom: 20px;
        }

        img {
            width: 200px;
            height: 200px;
            margin: 0 auto 20px;
        }
    }

    .qrCode-dialog::v-deep .el-dialog {
        width: 500px;
    }
</style>